/*
* 车辆油耗管理组件
* zxw
* 创建时间：
* 修改时间：2026-07-08
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Modal,
    Table,
    Select,
    Button,
    Upload,
    Tag,
    Space,
    Statistic,
    theme,
    Progress,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
    ImportOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    GetButtonActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './CarOilEntity';

const MODULENAME = CNF.navItems[1].submenu[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[2].ptn;
const MODULENAME_URL = CNF.navItems[1].submenu[2].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh, qss } = props;

    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,
            colorWarning,
            colorWarningBg,
            fontSize,
            pageSize,
        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '车牌号码', dataIndex: 'license_number', key: 'license_number', fixed: 'left', width: 120, },
        { title: '加油卡号', dataIndex: 'oil_card_number', key: 'oil_card_number', },
        { title: '油品类型', dataIndex: 'oil_type_number', key: 'oil_type_number', },

        {
            title: '加油数量(L)', key: 'quantity',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '60%' : '80%' }} color={colorPrimaryBg}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.quantity} /></Tag>
        },
        {
            title: '实时单价(元)', key: 'price',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '60%' : '80%' }} color={colorWarningBg}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorWarning } }} value={record.price} /></Tag>
        },
        {
            title: '加油金额(元)', key: 'amount',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '60%' : '80%' }} color={colorSuccessBg}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={record.amount} /></Tag>
        },
        { title: '加油时间', dataIndex: 'deal_time', key: 'deal_time', },
        { title: '加油地址', dataIndex: 'oil_address', key: 'oil_address', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, fontSize, colorPrimary, colorPrimaryBg, colorSuccess, colorWarning, colorSuccessBg, colorWarningBg]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <Space>
                        总计：<Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix='L' styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={qss?.quantity} /></Tag>
                        <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={qss && qss.amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={qss && qss.amount > 10000 ? qss.amount / 10000 : qss.amount} /></Tag>
                        共{pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条
                    </Space>,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </>
    );
}

const CarOil = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [qss, setQss] = useState(null);
    const [carLists, setCarLists] = useState([]);
    const [carUlid, setCarUlid] = useState('');
    const [oilTypeNumber, setOilTypeNumber] = useState('');

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleCarUlidChange = useCallback((value) => {
        setCarUlid(value);
        setCurrentIndex(1);
    }, []);

    const handleOilTypeNumberChange = useCallback((value) => {
        setOilTypeNumber(value || undefined);
        setCurrentIndex(1);
    }, []);

    useEffect(() => {
        // 获取车辆下拉列表
        const params = {
            rss: 'list',
            page_size: CNF.maxPageSize,
            current_index: 1
        };
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setCarLists(data.dat || []);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            car_ulid: carUlid,
            oil_type_number: oilTypeNumber,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
                setQss(data.qss || null);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, carUlid, oilTypeNumber]);

    // ---------- 导入相关 ----------
    const [modal, modalContextHolder] = Modal.useModal();
    const [instance, setInstance] = useState(null);

    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    const uploadCheck = useCallback((info) => {
        if (info.size > 10240000) {
            messageApi.error('上传文件超过10M，建议拆分文件！', CNF.messageDuration);
            return false;
        }
        if (!info.name.match(/.xls[x]{0,1}/)) {
            messageApi.error('文件格式不对，只支持 xls 或 xlsx ！', CNF.messageDuration);
            return false;
        }
        setInstance(
            modal.info({
                width: isGTscreenWidth ? 500 : 600,
                title: <Space>文件正在上传<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
                footer: null,
                icon: null,
                keyboard: false,
                closable: false,
            })
        );
        return true;
    }, [messageApi, modal]);

    /**
     * 更新导入弹框
     * @param {*} modal 
     * @param {*} title 
     * @param {*} data 
     * @param {*} percent 
     * @param {*} status 
     */
    const updateModal = useCallback((modalInstance, title, data, percent, status) => {
        modalInstance.update((prevConfig) => ({
            ...prevConfig,
            title,
            content: (
                <>
                    <Progress percent={percent} style={{ width: '100%' }} />
                    <Row style={{ marginTop: CNF.rowMarginTop }}>
                        <Col span={4}><strong>表格行号</strong></Col>
                        <Col span={12}><strong>车牌号码</strong></Col>
                        <Col span={8}><strong>操作说明</strong></Col>
                    </Row>
                    <div
                        id='import-modal-id'
                        style={{
                            height: 360,
                            marginTop: CNF.rowMarginTop,
                            overflowY: 'auto',
                        }}
                    >
                        {data.map((item, index) => (
                            <Row style={{ lineHeight: 2 }} key={index}>
                                <Col span={4}>{item.key}</Col>
                                <Col span={12}>{item.license_number}</Col>
                                <Col span={8} style={{ color: item.msg.includes('成功') ? '#000' : item.msg.includes('已导入') ? 'green' : 'red' }}>
                                    {item.msg}
                                </Col>
                            </Row>
                        ))}
                    </div>
                    {status === 'done' && (
                        <div style={{ marginTop: CNF.rowMarginTop * 2, width: '100%', textAlign: 'right' }}>
                            <Button
                                title='确定'
                                variant='solid'
                                style={{ background: global.THEMECOLOR, color: '#fff', border: 0 }}
                                onClick={() => {
                                    modalInstance.destroy();
                                    refresh();
                                }}
                            >
                                确定
                            </Button>
                        </div>
                    )}
                </>
            ),
        }));
    }, [refresh]);

    /**
     * 获取任务
     * @param {*} modal 
     * @param {*} jobId 
     */
    const getJob = useCallback(
        async (modalInstance, jobId) => {
            instance?.update((prevConfig) => ({
                ...prevConfig,
                title: <Space>车辆油耗正在导入<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
            }));

            const messageData = [];
            let total = 0;          // 总记录数（首次获取后固定）
            let processed = 0;      // 已处理记录数（累加）

            try {
                const response = await fetch(CNF.api + 'cars/oils/tasks?job_id=' + jobId, {
                    method: 'GET',
                    headers: AddRequestHeaders(),
                    openWhenHidden: true,
                });
                if (!response.ok) {
                    // 处理错误
                }
                const reader = response.body.getReader();
                const td = new TextDecoder('utf-8');
                let jsonData = null;
                while (true) {
                    const { done, value } = await reader.read();
                    const text = td.decode(value, { stream: true });
                    const jsonMatch = text.match(/data:\s*({.*?})\s*\n/);

                    // 计算进度（避免除零）
                    const percent = total > 0 ? (processed / total) * 100 : 0;
                    const percentFixed = parseFloat(percent.toFixed(CNF.DPL));

                    if (jsonMatch) {
                        jsonData = JSON.parse(jsonMatch[1]);
                    } else {
                        // 无有效数据，继续等待
                        if (done) {
                            // 更新进度
                            updateModal(
                                modalInstance,
                                `${MODULENAME}导入结束！`,
                                messageData,
                                percentFixed,
                                'done'
                            );
                            break
                        };
                        continue;
                    }

                    // 若服务端返回错误，直接终止
                    if (jsonData.res !== 0) {
                        modalInstance.destroy();
                        messageApi.error(jsonData.msg, CNF.messageDuration);
                        break;
                    }

                    // 首次获取 total，之后固定
                    if (total === 0 && jsonData.total) {
                        total = jsonData.total;
                    }

                    // 累加本批次记录数
                    const batchData = jsonData.data || [];
                    if (batchData.length) {
                        messageData.push(...batchData);
                        processed += batchData.length;
                    }

                    // 判断是否完成（服务端标识完成 或 已处理数达到总数）
                    const isFinished = jsonData?.id === jsonData?.total || processed >= total;

                    if (done || isFinished) {
                        // 完成时强制 100%
                        updateModal(
                            modalInstance,
                            isFinished ? `${MODULENAME}导入完成！` : `${MODULENAME}导入结束！`,
                            messageData,
                            100,
                            'done'
                        );
                        break;
                    } else {
                        // 更新进度
                        updateModal(
                            modalInstance,
                            <Space>{MODULENAME}正在导入<LoadingOutlined /></Space>,
                            messageData,
                            percentFixed,
                            'running'
                        );
                    }

                    // 滚动至底部
                    const div = document.getElementById('import-modal-id');
                    if (div) {
                        div.scrollTop = div.scrollHeight;
                        div.style.scrollBehavior = 'smooth';
                        div.scrollTo(0, div.scrollHeight);
                    }
                }
            } catch (e) {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    closable: true,
                    onCancel: () => refresh(),
                }));
                messageApi.error('网络错误 !', CNF.messageDuration);
            }
        },
        [instance, messageApi, updateModal, refresh]
    );

    /**
     * 执行导入
     * @param {*} info 
     */
    const upload = useCallback(
        (info) => {
            if (info.file.status === 'uploading') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={parseFloat(info.file.percent).toFixed(CNF.DPL)} />,
                }));
            } else if (info.file.status === 'done') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    title: '文件上传完成！',
                    content: <Progress percent={100} />,
                }));
                if (info.file.response?.dat) {
                    setTimeout(() => {
                        getJob(instance, info.file.response.dat.job_id);
                    }, 1000);
                } else {
                    instance?.destroy();
                    messageApi.error(info.file.response?.msg || '上传失败', CNF.messageDuration);
                }
            } else if (info.file.status === 'error') {
                instance?.destroy();
                messageApi.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
            }
        },
        [instance, getJob, messageApi]
    );

    /***
    * 导出为 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '车辆油耗明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '车辆油耗明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '车牌号码',
                    '加油卡号',
                    '油品类型',
                    '加油数量(L)',
                    '实时单价(元)',
                    '加油金额(元)',
                    '加油时间',
                    '加油地址',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出明细
     */
    const exportGetData = () => {
        let params = {
            page_size: pageSize,
            current_index: 1,
            car_ulid: carUlid,
            oil_type_number: oilTypeNumber,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    // 删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['car_ulid'];
                        delete item['create_username']
                        delete item['create_displayname']
                        delete item['create_time']
                        delete item['update_time']
                        d.push(item);
                    }
                    exportAsExcel(d);
                } else {
                    exportAsExcel([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasImport = btnLists.includes(MODULENAME_PTN + '_import');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            {modalContextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    showSearch
                    allowClear
                    placeholder='请选择车辆'
                    style={{ width: '100%' }}
                    onChange={handleCarUlidChange}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={carLists && carLists.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.license_number,
                    }))}
                />
                <Select
                    allowClear
                    placeholder='请选择油品'
                    style={{ width: '100%' }}
                    onChange={handleOilTypeNumberChange}
                    popupMatchSelectWidth={false}
                    options={CNF.oilTypeNumbers && CNF.oilTypeNumbers.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key,
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasImport && (
                    <Upload
                        action={CNF.api + 'cars/oils/tasks'}
                        headers={AddRequestHeaders(false)}
                        onChange={upload}
                        beforeUpload={uploadCheck}
                        showUploadList={false}
                        name='file'
                        accept='xlsx,xls'
                    >
                        <Button
                            title={CNF.actionName.IMPORT + MODULENAME}
                            color='primary'
                            variant='solid'
                            icon={<ImportOutlined />}
                        >
                            {CNF.actionName.IMPORT}
                        </Button>
                    </Upload>
                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
                qss={qss}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                carLists={carLists}
            />
        </>
    );
}

export default CarOil